<template>
    <div v-if="device">
        <div class="container repair-container">

            <!-- Filter -->
            <div class="row">
                <div class="col-md-12">
                    <label class="mt-2">Enter the details of faults identified through diagnostics</label>
                </div>
            </div>

            <!-- Data entry -->
            <div class="row mb-4">
                <div class="col-md-12">
                    <label>Fault description</label>
                    <textarea v-model="description" class="form-control" rows="3" maxlength="300" placeholder="Enter a description"></textarea>
                    <p class="text-left text-muted text-xs pl-1 mb-0">Enter a minimum of 20 characters</p>
                </div>
            </div>

            <div class="row mb-5">
                <div class="col-md-12">
                    <label>Fault occurrence frequency</label>
                    <select v-model="frequency" class="custom-select">
                        <option :value="null">Select frequency of occurrence</option>
                        <option value="Always">Always</option>
                        <option value="More than once a day">More than once a day</option>
                        <option value="Once a day">Once a day</option>
                        <option value="Intermittent">Intermittent</option>
                    </select>
                </div>
            </div>

            <div class="row" v-if="screens.length > 0 && appRegion === 'UK'">
                <div class="col-md-12">
                    <label>Screen Salvage Triage</label>
                    <div v-for="(screen, index) in screens" :key="screen.screen_id" class="mt-2">
                        <p><strong>{{screen.title}}</strong></p>

                        <p class="mb-0">Does the current display power on?</p>
                        <ul class="list-group selection-list mb-4">
                            <li class="list-group-item" :class="{'active': screens[index].power === 'yes'}">
                                <label class="custom-control custom-radio mb-0">
                                    <input type="radio" class="custom-control-input" :name="'triageAnswerPower'+(index)" value="yes" :id="'power-on-yes'+(index)" v-model="screens[index].power">
                                    <label class="custom-control-label mb-0" :for="'power-on-yes'+(index)">Yes</label>
                                </label>
                            </li>
                            <li class="list-group-item" :class="{'active': screens[index].power === 'no'}">
                                <label class="custom-control custom-radio mb-0">
                                    <input type="radio" class="custom-control-input" :name="'triageAnswerPower'+index" value="no" :id="'power-on-no'+index" v-model="screens[index].power">
                                    <label class="custom-control-label mb-0" :for="'power-on-no'+index">No</label>
                                </label>
                            </li>
                        </ul>

                        <p class="mb-0">Does the display respond to touch?</p>
                        <ul class="list-group selection-list mb-4">
                            <li class="list-group-item" :class="{'active': screens[index].touch === 'yes'}">
                                <label class="custom-control custom-radio mb-0">
                                    <input type="radio" class="custom-control-input" :name="'triageAnswerTouch'+index" value="yes" :id="'touch-yes'+index" v-model="screens[index].touch">
                                    <label class="custom-control-label mb-0" :for="'touch-yes'+index">Yes</label>
                                </label>
                            </li>
                            <li class="list-group-item" :class="{'active': screens[index].touch === 'no'}">
                                <label class="custom-control custom-radio mb-0">
                                    <input type="radio" class="custom-control-input" :name="'triageAnswerTouch'+index" value="no" :id="'touch-no'+index" v-model="screens[index].touch">
                                    <label class="custom-control-label mb-0" :for="'touch-no'+index">No</label>
                                </label>
                            </li>
                        </ul>

                        <p class="mb-0">Is there any evidence of Screen Bleed/Burn?</p>
                        <ul class="list-group selection-list">
                            <li class="list-group-item" :class="{'active': screens[index].burnbleed === 'yes'}">
                                <label class="custom-control custom-radio mb-0">
                                    <input type="radio" class="custom-control-input" :name="'triageAnswerBleedBurn'+index" value="yes" :id="'burnbleed-yes'+index" v-model="screens[index].burnbleed">
                                    <label class="custom-control-label mb-0" :for="'burnbleed-yes'+index">Yes</label>
                                </label>
                            </li>
                            <li class="list-group-item" :class="{'active': screens[index].burnbleed === 'no'}">
                                <label class="custom-control custom-radio mb-0">
                                    <input type="radio" class="custom-control-input" :name="'triageAnswerBleedBurn'+index" value="no" :id="'burnbleed-no'+index" v-model="screens[index].burnbleed">
                                    <label class="custom-control-label mb-0" :for="'burnbleed-no'+index">No</label>
                                </label>
                            </li>
                        </ul>

                    </div>

                    <button class="btn btn-success btn-block btn-lg mt-3 btn-rounded" :disabled="submitTriageBlocked" @click="sendTriage">Submit Triage</button>
                </div>
            </div>
            <!-- Footer -->
            <fixed-footer
                @previousButtonClicked="saveDetails()"
                @nextButtonClicked="saveDetails()"
                :class="{'active': footerActive}"
                :nextLabel="this.nextRepairStep($route.name).title"
                :nextRoute="this.nextRepairStep($route.name).routeName"
                :prevRoute="this.prevRepairStep($route.name).routeName">
            </fixed-footer>

        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
    props:["jobId", "deviceId"],

    data() {
        return {
            description: null,
            frequency: null,
            screens: [],
            triagePassed: false
        }
    },

    mounted() {
        this.loadDeviceForJob({
            jobId: this.jobId,
            deviceId: this.deviceId,
        }).then(() => {
            this.setCurrentStep({
                jobId: this.jobId,
                deviceId: this.deviceId,
                currentStep: this.$route.name,
            });
            this.description = this.device.customer_fault_description;
            this.frequency = this.device.fault_occurrence_frequency;
        });

        this.fetchScreensForDevice({
            jobId: this.jobId,
            deviceId: this.deviceId,
        }).then((response) => {
            response.data.data.forEach(screen => {
                let power = '';
                let touch = '';
                let burnbleed = '';

                if (screen.grading) {
                    this.triagePassed = true;
                }

                if (screen.grading === 1) {
                    power = 'yes';
                    touch = 'yes'
                    burnbleed = 'no';

                } else if (screen.grading === 2) {
                    power = 'no';
                    touch = 'no'
                    burnbleed = 'no';

                } else if (screen.grading === 3) {
                    power = 'no';
                    touch = 'no'
                    burnbleed = 'yes';
                }

                this.screens.push({
                    screen_id: screen.id,
                    title: screen.title,
                    power: power,
                    touch: touch,
                    burnbleed: burnbleed
                });
            });
        });
    },

    computed: {
        ...mapGetters([
            "appRegion",
            "device",
            "isJobManager",
            "nextRepairStep",
            "prevRepairStep",
        ]),

        submitTriageBlocked() {
            return this.screens.some(screen => {
                return screen.power === '' || screen.touch === '' || screen.burnbleed === '';
            });
        },

        /** Check if footer should be active */
        footerActive() {
            if (!this.description || this.description.length < 20 || !this.frequency) {
                return false;
            }
            if (this.screens.length > 0 && this.appRegion === 'UK') {
                if (!this.triagePassed) {
                    return false;
                }
            }

            return true;
        }
    },

    methods: {
        ...mapActions([
            "displayToast",
            "loadDeviceForJob",
            "setCurrentStep",
            "setDefectDescriptions",
            "fetchScreensForDevice",
            "sendScreenSalvageTriage"
        ]),
        sendTriage(){
            this.sendScreenSalvageTriage({
                jobId: this.jobId,
                deviceId: this.deviceId,
                screenTriage: this.screens
            }).then(() => {
                this.displayToast({text: 'Salvage data saved', type: 'success'});
                this.triagePassed = true;
            });
        },
        saveDetails() {
            this.setDefectDescriptions({
                deviceId: this.deviceId,
                description: this.description,
                frequency: this.frequency
            }).catch((error) => {
                this.displayToast({text: error, type: 'danger'});
            });
        }
    }
}
</script>

<style scoped>

</style>